import { buildProps } from '@element-plus/utils'
import type { ExtractPropTypes } from 'vue'

export const anchorLinkProps = buildProps({
  /**
   * @description control the href of anchor-link
   */
  href: {
    type: String,
    default: '#',
  },
  /**
   * @description control the title of anchor-link
   */
  title: String,
  /**
   * @description control the target of anchor-link
   */
  target: String,
} as const)

export type AnchorLinkProps = ExtractPropTypes<typeof anchorLinkProps>

export interface AnchorLinkPayload {
  target?: string
  href: string
  title?: string
}

export interface AnchorLinkSection {
  link: string
  top: number
}
